import classNames from 'classnames';
import CurrencyFormat from 'components/CurrencyFormat';
import DurationFormat from 'components/DurationFormat';
import React from 'react';
import type { Currency } from 'types/account';
import type { BudgetType } from 'types/project';
import { REPORT_DURATION_FORMAT } from '../../constants';
import styles from '../TableWidget.module.scss';
import { TableWidgetPlaceholderBlock } from './TableWidgetPlaceholderBlock';

interface Props {
  animated?: boolean;
  className?: string;
  currency?: Currency;
  type?: BudgetType;
  value?: number;
}

const TableWidgetBudgetValueBlock: React.FC<Props> = ({
  animated = false,
  className,
  currency,
  type,
  value,
}) => {
  if (value == null || !type) return <TableWidgetPlaceholderBlock />;

  const wrapperClass = classNames(
    {
      [styles.negative]: value < 0,
    },
    className
  );

  if (type === 'H') {
    return (
      <DurationFormat
        animated={animated}
        className={wrapperClass}
        format={REPORT_DURATION_FORMAT}
        valueType="hours"
        value={value}
        zeroPlaceholder={<TableWidgetPlaceholderBlock />}
      />
    );
  }

  if (!currency) return <TableWidgetPlaceholderBlock />;

  return <CurrencyFormat animated={animated} className={wrapperClass} value={value} />;
};

export default TableWidgetBudgetValueBlock;
